<template>
  <div
    class="section-header"
    :class="{ 'section-header--rounded-top': roundedTop }"
  >
    <div class="section-header__titles">
      <span class="sk-text-large-semibold">{{ title }}</span>
      <span class="sk-text-small-regular text--blue">{{ description }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    roundedTop: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.section-header {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  background-color: $sk-grey-5;
}

.section-header--rounded-top {
  border-radius: 8px 8px 0 0;
}

.section-header__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
